$('document').ready(function () {
    var currentUser = '';


    // $.ajax({
    //         // headers: {
    //         //     'X-CSRF-TOKEN': window.Laravel.csrfToken
    //         // },
    //         url: "https://www.test.ai-interceptor.tk",
    //         dataType: 'json',
    //         type: 'GET',
    //     }
    // ).done(function (result) {
    //     console.log(result);
    //
    // }).fail();


    function ChangeForm() {
        if (document.getElementById('FS-TYPE')) {
            currentUser = $("#FS-TYPE").val();
            if (currentUser == 'People') {
                $("#ForPeople").show();
                $("#ForProject").hide();
                $(".forLaunchNewProject ").addClass("hidden");
                $(".allPages").removeClass("hidden");
            } else {
                $("#ForPeople").hide();
                $("#ForProject").show();
                $(".allPages").addClass("hidden");
                $(".forLaunchNewProject ").removeClass("hidden");
            }
        }
    };

    $(window).load(function () {
        ChangeForm();
    });
    $("#FS-TYPE").change(function () {
        ChangeForm();
    });

//============================  ������ ��� ����� �� ���� � ������  =============================

    // $("#footerNavMenu").on("click", "a", function (event) {
    //     event.preventDefault();
    //     var id = $(this).attr('href'),
    //         top = $(id).offset().top;
    //     $('body,html').animate({scrollTop: top}, 1300);
    // });
});
